import styled from 'styled-components'
import { Button } from '@material-ui/core'

export const StyledWrapper = styled.div`
  border: ${props => `1px solid ${props.theme.colors.primary}`};
  border-radius: 4px;
  display: flex;
  height: 40px;
  width: 173.7px;
`

export const StyledButton = styled(Button)`
  && {
    border: 0;
    border-radius: 0;
    flex: 1;
    font-family: ${props => props.theme.fonts.robotoRegular};
    font-size: 13px;
    text-transform: capitalize;
    ${props =>
      props.selected
        ? `background-color: ${props.theme.colors.primary};
           color: #fff;
           
           &:hover {
             background-color: ${props.theme.colors.primary};
             color: #fff;
           }`
        : `color: ${props.theme.colors.primary};
        
           &:hover {
             background-color: transparent;
           }`}
  }
`
